<template>
  <div id="topNavPablo" v-if="global.screenWidth < 1125">
    <MobileNav :siteId="siteId" :pablo="true">
      <slot></slot>
    </MobileNav>
    <div class="toggle">
      <p class="english" :class="{ active: !spanish}">EN</p>
      <span
        class="toggle-wrapper"
        role="checkbox"
        :aria-checked="spanish.toString()"
        tabindex="0"
        @click="toggled"
        @keydown.space.prevent="toggle"
      >
        <span
          class="toggle-background"
          :class="backgroundStyles"
        />
        <span
          class="toggle-indicator"
          :style="indicatorStyles" 
        />
      </span>
      <p class="spanish" :class="{ active: spanish }">ES</p>
    </div>
  </div>
  <div id="topNavPablo" v-else>
    <PrimaryNav :siteId="siteId" :spanish="spanish" :pablo="true">
      <slot></slot>
    </PrimaryNav>
    <div class="toggle">
      <p class="english" :class="{ active: !spanish}">EN</p>
      <span
        class="toggle-wrapper"
        role="checkbox"
        :aria-checked="spanish.toString()"
        tabindex="0"
        @click="toggled"
        @keydown.space.prevent="toggle"
      >
        <span
          class="toggle-background"
          :class="backgroundStyles"
        />
        <span
          class="toggle-indicator"
          :style="indicatorStyles" 
        />
      </span>
      <p class="spanish" :class="{ active: spanish }">ES</p>
    </div>
  </div>
</template>

<script>
import PrimaryNav from "./PrimaryNav";
import MobileNav from "./MobileNav";
import { mapState } from "vuex";
export default {
  name: "TopNavPablo",
  components: {
    PrimaryNav,
    MobileNav,
  },
  props: {
    siteId: {
      type: String,
      required: true,
    },
    spanish: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState(["global"]),
    backgroundStyles() {
      return null
    },
    indicatorStyles() {
      return { transform: this.spanish ? 'translateX(14px)' : 'translateX(0)' };
    }
  },
  methods: {
    toggled() {
      this.$emit('input', !this.spanish)
    }
  }
};
</script>

<style lang="scss" scoped>
#topNavPablo {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999;
  .toggle {
    position: absolute;
    top: 30px;
    right: 33px;
    display: flex;
    flex-direction: row;
    align-items: center;
    @media (max-width: 1125px) {
      top: 17px;
      right: 16px;
      z-index: 99;
    }

    &-wrapper {
      display: inline-block;
      position: relative;
      cursor: pointer;
      width: 34.7px;
      height: 19px;
      border-radius: 100px;
      border: 2px solid #eaeaea;
      background-color: #f6f6f6;
      &:focus {
        outline: 0;
      }
    }
    &-indicator {
      position: absolute;
      height: 13px;
      width: 13px;
      left: 2px;
      bottom: 1px;
      background-color: #ce0e2d;
      border-radius: 50%;
      transition: transform 0.3s ease;
    }
    p {
      font-family: Poppins-SemiBold;
      font-size: 14px;
      line-height: 20px;
      color: #7f7f7f;
      transition: color 0.3s ease-in-out;
      &.active {
        color: #ce0e2d;
        transition: color 0.3s ease-in-out;
      }
      &.english {
        margin-right: 3px;
      }
      &.spanish {
        margin-left: 3px;
      }
    }
  }
}
</style>